// extracted by mini-css-extract-plugin
export default {"mappingsGrid":"SalesFees_mappingsGrid__Tm4Vf"};